import * as React from "react";
import { ActivateCallback } from "src/types/ActivateCallback";

import { ZAttrMeta } from "../ZAttrMeta";
import { AttrDatePicker } from "./AttrDatePicker";
import { AttrEditInput } from "./AttrEditInput";
import { AttrEditSwitch } from "./AttrEditSwitch";
import { AttrInputNumber } from "./AttrInputNumber";

type PropsAttrEditDefault = {
  attr: ZAttrMeta;
  value: unknown;
  onChange?(value?: unknown): void;
  disabled?: boolean;
  activateCallback?: ActivateCallback;
  onBlur: () => void;
};

export const AttrEditDefault: React.FC<PropsAttrEditDefault> = ({
  attr,
  value,
  onChange,
  disabled,
  activateCallback,
  onBlur,
}) => {
  switch (attr.type.name) {
    case "string":
      return (
        <AttrEditInput
          attrMeta={attr}
          value={value}
          onChange={onChange}
          disabled={disabled}
          activateCallback={activateCallback}
          onBlur={onBlur}
        />
      );

    case "number":
      return (
        <AttrInputNumber
          attrMeta={attr}
          value={value}
          onChange={onChange}
          disabled={disabled}
          activateCallback={activateCallback}
          onBlur={onBlur}
        />
      );
    case "boolean":
      return (
        <AttrEditSwitch
          attrMeta={attr}
          value={value}
          onChange={onChange}
          disabled={disabled}
          activateCallback={activateCallback}
          onBlur={onBlur}
        />
      );
    case "dateTime":
      return (
        <AttrDatePicker
          attrMeta={attr}
          value={value}
          onChange={onChange}
          disabled={disabled}
          activateCallback={activateCallback}
          onBlur={onBlur}
        />
      );
    default:
      break;
  }
  return null;
};
